// Rótulos/cores dos enums de Ticket (status/prioridade) - cor lisa fixa
// (não usa color= do MUI), mesma convenção já usada pra status de pedido/
// negócio em DealConversationCard.js.
export const STATUS_LABELS = {
    new: 'Novo',
    open: 'Aberto',
    in_progress: 'Em andamento',
    pending: 'Pendente',
    resolved: 'Resolvido',
    closed: 'Fechado'
};

export const STATUS_COLORS = {
    new: { bg: '#E3E8EF', color: '#334155' },
    open: { bg: '#DCEEFF', color: '#0B5FA5' },
    in_progress: { bg: '#FFF3CD', color: '#8A6D00' },
    pending: { bg: '#FDE4CF', color: '#9A4A00' },
    resolved: { bg: '#D6F5DD', color: '#1B7A3D' },
    closed: { bg: '#E5E5E5', color: '#555555' }
};

export const PRIORITY_LABELS = {
    low: 'Baixa',
    normal: 'Normal',
    high: 'Alta',
    urgent: 'Urgente'
};

export const PRIORITY_COLORS = {
    low: { bg: '#E5E5E5', color: '#555555' },
    normal: { bg: '#DCEEFF', color: '#0B5FA5' },
    high: { bg: '#FDE4CF', color: '#9A4A00' },
    urgent: { bg: '#FBD5D5', color: '#B42121' }
};

export const STATUS_ORDER = ['new', 'open', 'in_progress', 'pending', 'resolved', 'closed'];

export const formatTicketDate = (value) => {
    if (!value) return '—';
    try {
        return new Date(value).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
    } catch {
        return '—';
    }
};

// ID curto pra exibição (ex: "#3F9A2C") - o Ticket usa UUID, mostrar
// inteiro não cabe/não ajuda numa lista ou cabeçalho.
export const shortTicketId = (id) => (id ? `#${String(id).slice(0, 8).toUpperCase()}` : '');
